import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BACKEND
})

const getUserInfo = (user) => {
  return instance.get('/info')
}

const requestPasswordCode = (email) => {
  return instance.post('/forgot', email)
}

const getDefaultPermissionsList = () => {
  return instance.get('/permissions')
}

export default {
  getDefaultPermissionsList,
  getUserInfo,
  requestPasswordCode
}
